import { useEffect } from "react";
import { Button, Loading, Typography } from "@/components/atoms";
import { useLazyGetGoogleTagManagerConfigurationQuery } from "@/redux/apis/addOn/addOnApi";
import { GoogleTagManagerConfiguration } from "@/redux/slices/addOn/types";

interface GoogleTagManagerDetailsProps {
  onEdit: () => void;
  configuration?: GoogleTagManagerConfiguration;
}

export const GoogleTagManagerDetails = ({ onEdit, configuration }: GoogleTagManagerDetailsProps) => {
  const [getGoogleTagManagerConfiguration, { isFetching }] = useLazyGetGoogleTagManagerConfigurationQuery();

  useEffect(() => {
    getGoogleTagManagerConfiguration();
  }, [getGoogleTagManagerConfiguration]);

  return (
    <div className="relative my-4 flex w-full flex-col rounded-lg bg-neutral-surface-gray p-5">
      {isFetching && <Loading className="rounded-lg" />}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <div className="flex flex-1 flex-col">
          <Typography variant="action">GTM Property ID</Typography>
          <Typography variant="paragraph" className="text-neutral-dark-gray">
            Set your property ID
          </Typography>
        </div>
        <Typography variant="paragraph">{configuration?.property}</Typography>
      </div>
      <div className="mt-8 flex w-full flex-row items-center justify-end">
        <Button variant="primary" size="sm" onClick={onEdit}>
          Edit Settings
        </Button>
      </div>
    </div>
  );
};
